export const navItems = [
  {
    title: true,
    name: "MENU_USER",
  },
  {
    name: "MENU_ANALYTICS",
    url: "/analytics",
    icon: "icon-graph",
    children: [
      {
        name: "MENU_DASHBOARD",
        url: "/analytics/dashboard",
        icon: "icon-globe",
      },
      {
        name: "MENU_ANALYTICS_INGRESS",
        url: "/analytics/ingress",
        icon: "icon-chart",
      },
      /* {
         name: 'MENU_ANALYTICS_CASHER',
         url: '/analytics/casher',
         icon: 'icon-basket'
       },*/
      {
        name: "MENU_ANALYTICS_LIGHTS",
        url: "/analytics/lights",
        icon: "icon-bulb",
      },
      {
        name: "MENU_ANALYTICS_HEATMAPS",
        url: "/analytics/heatmaps",
        icon: "icon-fire",
      },
      {
        name: "MENU_ANALYTICS_GENDER",
        url: "/analytics/gender",
        icon: "icon-people",
      },
      {
        name: "MENU_ANALYTICS_IDEOGATES",
        url: "/analytics/ideogates",
        icon: "icon-speedometer",
      },
    ],
  },
  {
    name: "MENU_MEDIAS",
    url: "/medias",
    icon: "icon-eye",
    children: [
      {
        name: "MENU_MEDIAS_CONTENTS",
        url: "/medias/contents",
        icon: "icon-folder",
      },
      /* {
         name: 'MENU_MEDIAS_PLAYLISTS',
         url: '/medias/playlists',
         icon: 'icon-list'
       },*/
      {
        name: "MENU_MEDIAS_SCHEDULES",
        url: "/medias/schedules",
        icon: "icon-calendar",
      },
    ],
  },
  {
    title: true,
    name: "MENU_ADMIN",
  },
  {
    name: "MENU_PARTNERS",
    icon: "icon-people",
    url: "/admin/areas/partner",
  },
  {
    name: "MENU_CLIENT",
    icon: "icon-user",
    url: "/admin/areas/client",
  },
  {
    name: "MENU_LOCATION",
    icon: "icon-direction",
    url: "/admin/areas/location",
  },
  {
    name: "MENU_AREAS",
    icon: "icon-layers",
    url: "/admin/areas/area",
  },
  {
    name: "MENU_DEVICES",
    url: "/admin/devices",
    icon: "icon-frame",
    children: [
      {
        name: "MENU_DEVICES_LIST",
        icon: "icon-frame",
        url: "/admin/devices/list",
      },
      /* {
         name: 'MENU_DEVICES_DISPLAY',
         icon: 'icon-screen-desktop',
         url: '/admin/devices/displays',
       },*/
      {
        name: "MENU_LOST_DEVICES",
        icon: "icon-feed",
        url: "/admin/devices/lost",
      },
    ],
  },
  {
    name: "MENU_SIALINK",
    icon: "icon-shield",
    url: "/admin/sialink",
  },
  {
    name: "MENU_REPORTS",
    icon: "icon-note",
    url: "/admin/reports/list",
  },
  {
    name: "MENU_CONFIGURATION",
    url: "/settings",
    icon: "icon-settings",
    children: [
      {
        name: "MENU_COMMANDS_LIST",
        icon: "icon-energy",
        url: "/settings/commands/list",
      },
      {
        name: "MENU_USERS",
        icon: "icon-user",
        url: "/settings/users/list",
      },
      {
        name: "MENU_CUSTOMFIELDS",
        icon: "icon-grid",
        url: "/settings/customfields/list",
      },
      {
        name: "MENU_TYPES",
        icon: "icon-directions",
        url: "/settings/types/list",
      },
    ],
  },
];
